import { useEffect, useState } from "react";
import { capi } from "./chatApi";

export const ChatUnreadBadge = ({ active }) => {
  const [n, setN] = useState(0);
  useEffect(() => {
    const load = () => capi("get", "/chat/unread").then((r) => setN(r.total || 0)).catch(() => {});
    load();
    const t = setInterval(load, 30000);
    window.addEventListener("chat-read", load);
    return () => { clearInterval(t); window.removeEventListener("chat-read", load); };
  }, []);
  if (!n) return null;
  return <span className={`rounded-full px-1.5 text-[10px] font-bold ${active ? "bg-white text-indigo-700" : "bg-rose-500 text-white"}`} data-testid="nav-chat-unread">{n > 99 ? "99+" : n}</span>;
};
